import { render, staticRenderFns } from "./UserGroupSelector.vue?vue&type=template&id=565c8428&scoped=true&"
import script from "./UserGroupSelector.vue?vue&type=script&lang=ts&"
export * from "./UserGroupSelector.vue?vue&type=script&lang=ts&"
import style0 from "./UserGroupSelector.vue?vue&type=style&index=0&id=565c8428&lang=scss&scoped=true&"
import style1 from "./UserGroupSelector.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565c8428",
  null
  
)

export default component.exports